import { z } from 'zod'

export const AssociarFuncionariosSchema = z
    .object({
        funcionarios: z
            .object({
                funcionarioIds: z.array(z.coerce.number()).default([]),
                dtInicial: z.coerce.date().optional().nullable(),
                dtFinal: z.coerce
                    .string()
                    .optional()
                    .nullish()
                    .transform(v => (v ? new Date(v) : null))
                    .refine(
                        data => !data || data.toString() !== 'Invalid Date',
                        { message: 'Data final inválida' },
                    ),
            })
            .default({ funcionarioIds: [] }),
    })
    .superRefine((data, ctx) => {
        if (
            data.funcionarios.funcionarioIds.length > 0 &&
            !data.funcionarios.dtInicial
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    'Data inicial é obrigatória ao selecionar funcionários',
                path: ['funcionarios', 'dtInicial'],
            })
        }
    })

export type AssociarFuncionarios = z.infer<typeof AssociarFuncionariosSchema>
